import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { VehicleListDTO } from 'src/app/base/models/models.swagger.generated';
import { EnumFilterService } from 'src/app/base/services/enum-filter.service';
import { DynamicGridBaseComponent } from 'src/app/base/shared/grid-base/dynamic-grid-base.component';
import { SearchFieldComponent } from 'src/app/base/shared/search-field/search-field.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { SamplingProfilesService } from '../sampling-profiles/sampling-profiles.service';
import { AssignProfileDialogComponent } from './assign-profile-dialog/assign-profile-dialog.component';
import { SamplingProfileLookupService } from './sampling-profile-lookup.service';
import { vehiclesDynamicDefinition } from './vehicles-dynamic.definition';
import { VehiclesService } from './vehicles.service';

/**
 * Read-only vehicle list — vehicles are created and updated only by device ingestion. The one
 * action available here is reassigning which sampling profile a vehicle runs.
 */
@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss'],
  imports: [SearchFieldComponent, GridModule, AssignProfileDialogComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [VehiclesService, SamplingProfilesService, SamplingProfileLookupService],
})
export class VehiclesComponent extends DynamicGridBaseComponent<typeof vehiclesDynamicDefinition> implements OnInit {

  public selectedVehicle: VehicleListDTO | null = null;
  public showAssignDialog = false;

  constructor(
    private vehiclesService: VehiclesService,
    fb: FormBuilder,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    enumFilterService: EnumFilterService,
  ) {
    super(vehiclesDynamicDefinition, fb, null, translateService, vehiclesService, enumFilterService);
    this.searchOptions = { fields: this.crudDefinition.grid.searchFields };
  }

  public ngOnInit(): void {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.vehiclesService, this.spinnerService),
    });
    this.editSettings = {
      allowAdding: false,
      allowEditing: false,
      allowDeleting: false,
      mode: 'Dialog',
      showDeleteConfirmDialog: false,
    };
    this.gridCommands = [{
      type: 'None',
      title: this.translateService.instant('i18n.domain.vehicles.assign-profile-tooltip'),
      buttonOption: {
        cssClass: 'icon-btn',
        iconCss: 'icon-edit e-icons',
      },
    } as CommandModel];
  }

  public commandClick(args: CommandClickEventArgs): void {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      this.selectedVehicle = args.rowData as VehicleListDTO;
      this.showAssignDialog = true;
    }
  }

  public onAssigned(): void {
    this.grid?.refresh();
  }

  protected getEditDialogTitleParams(): object {
    return {};
  }
}
